/* Gluten Free Bakery — global.js */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     Menu mobilne
     ------------------------------------------------------------------ */
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = document.getElementById(btn.getAttribute('aria-controls'));
      if (!nav) return;
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ------------------------------------------------------------------
     Selektory ilości (− n +)
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-change'), 10) || 1;
    var min = parseInt(input.min, 10) || 0;
    var next = (parseInt(input.value, 10) || 0) + step;
    if (next < min) next = min;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------------------
     Koszyk: automatyczne przeliczenie po zmianie ilości
     ------------------------------------------------------------------ */
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    var submitTimer;
    cartForm.addEventListener('change', function (e) {
      if (!e.target.matches('[data-line-quantity]')) return;
      clearTimeout(submitTimer);
      submitTimer = setTimeout(function () { cartForm.submit(); }, 300);
    });

    var invoiceToggle = cartForm.querySelector('[data-invoice-toggle]');
    var invoiceFields = cartForm.querySelector('[data-invoice-fields]');
    if (invoiceToggle && invoiceFields) {
      var syncInvoice = function () {
        invoiceFields.hidden = !invoiceToggle.checked;
        if (!invoiceToggle.checked) {
          invoiceFields.querySelectorAll('input').forEach(function (i) { i.value = ''; });
        }
      };
      invoiceToggle.addEventListener('change', syncInvoice);
      syncInvoice();
    }
  }

  /* ------------------------------------------------------------------
     Galeria produktu: podmiana głównego zdjęcia
     ------------------------------------------------------------------ */
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!main) return;
        main.src = thumb.getAttribute('data-full-src') || thumb.src;
        if (thumb.alt) main.alt = thumb.alt;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });
  });

  /* ------------------------------------------------------------------
     Wybór wariantu: dopasowanie wariantu do opcji, cena, dostępność
     ------------------------------------------------------------------ */
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var dataEl = root.querySelector('[data-variants-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var buttonEl = root.querySelector('[data-add-button]');
    var buttonText = root.querySelector('[data-add-button-text]');
    var moneyFormat = root.getAttribute('data-money-format') || '{{amount}} zł';
    var strings = {
      add: root.getAttribute('data-text-add') || 'Dodaj do koszyka',
      soldOut: root.getAttribute('data-text-sold-out') || 'Wyprzedane',
      unavailable: root.getAttribute('data-text-unavailable') || 'Niedostępne'
    };

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2).replace('.', ',');
      return moneyFormat
        .replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount)
        .replace(/<[^>]+>/g, '');
    }

    function selectedOptions() {
      var opts = [];
      root.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) opts[parseInt(group.getAttribute('data-option-index'), 10)] = checked.value;
      });
      return opts;
    }

    function update() {
      var opts = selectedOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (value, i) { return value === opts[i]; });
      });

      if (match) {
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = formatMoney(match.price);
        if (buttonEl) buttonEl.disabled = !match.available;
        if (buttonText) buttonText.textContent = match.available ? strings.add : strings.soldOut;
      } else {
        if (buttonEl) buttonEl.disabled = true;
        if (buttonText) buttonText.textContent = strings.unavailable;
      }
    }

    root.querySelectorAll('[data-option-index] input').forEach(function (input) {
      input.addEventListener('change', update);
    });
    update();
  });

  /* ------------------------------------------------------------------
     Popup zasad — tylko pierwsza wizyta
     ------------------------------------------------------------------ */
  var popup = document.querySelector('[data-rules-popup]');
  if (popup) {
    var storageKey = 'gfb-rules-popup-v3-dismissed';
    var dismissed = false;
    try { dismissed = window.localStorage.getItem(storageKey) === '1'; } catch (err) {}
    var inEditor = window.Shopify && window.Shopify.designMode;

    var close = function () {
      popup.classList.remove('is-open');
      try { window.localStorage.setItem(storageKey, '1'); } catch (err) {}
    };

    if (!dismissed && !inEditor) {
      var delay = parseInt(popup.getAttribute('data-delay'), 10) || 1500;
      setTimeout(function () { popup.classList.add('is-open'); }, delay);
    }

    popup.querySelectorAll('[data-popup-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    popup.addEventListener('click', function (e) {
      if (e.target === popup) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) close();
    });

    if (inEditor) {
      document.addEventListener('shopify:section:select', function (e) {
        if (e.target.contains(popup)) popup.classList.add('is-open');
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.target.contains(popup)) popup.classList.remove('is-open');
      });
    }
  }

  /* ------------------------------------------------------------------
     Mobilny panel kategorii (dolny przycisk + arkusz)
     ------------------------------------------------------------------ */
  var catSheet = document.getElementById('CatSheet');
  if (catSheet) {
    var catOpeners = document.querySelectorAll('[data-cat-open]');
    var openCatSheet = function () {
      catSheet.hidden = false;
      requestAnimationFrame(function () { catSheet.classList.add('is-open'); });
      document.body.classList.add('cat-sheet-open');
      catOpeners.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    };
    var closeCatSheet = function () {
      catSheet.classList.remove('is-open');
      document.body.classList.remove('cat-sheet-open');
      catOpeners.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      setTimeout(function () { catSheet.hidden = true; }, 300);
    };
    catOpeners.forEach(function (b) { b.addEventListener('click', openCatSheet); });
    catSheet.querySelectorAll('[data-cat-close]').forEach(function (el) {
      el.addEventListener('click', closeCatSheet);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && catSheet.classList.contains('is-open')) closeCatSheet();
    });
  }

  /* ------------------------------------------------------------------
     Filtry kolekcji: auto-submit po zmianie
     ------------------------------------------------------------------ */
  document.querySelectorAll('[data-collection-filters]').forEach(function (form) {
    form.addEventListener('change', function () { form.submit(); });
  });

  /* ------------------------------------------------------------------
     Szybkie dodawanie do koszyka z listy produktów (bez opuszczania listy)
     ------------------------------------------------------------------ */
  (function () {
    var ctas = document.querySelectorAll('[data-card-cta]');
    if (!ctas.length) return;

    function setCartCount(n) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    }
    function showStepper(cta, qty) {
      var form = cta.querySelector('.product-card__addform');
      var step = cta.querySelector('[data-card-stepper]');
      if (form) form.style.display = 'none';
      if (step) { step.hidden = false; var q = step.querySelector('[data-line-qty]'); if (q) q.textContent = qty; }
    }
    function showButton(cta) {
      var form = cta.querySelector('.product-card__addform');
      var step = cta.querySelector('[data-card-stepper]');
      if (step) step.hidden = true;
      if (form) { form.style.display = ''; var b = form.querySelector('[data-quick-add]'); if (b) b.disabled = false; }
    }
    function refreshFromCart(cb) {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          setCartCount(cart.item_count);
          var byVariant = {};
          cart.items.forEach(function (it) { byVariant[it.variant_id] = (byVariant[it.variant_id] || 0) + it.quantity; });
          if (cb) cb(byVariant);
        })
        .catch(function () {});
    }

    // Stan początkowy — pokaż stepper dla produktów już w koszyku
    refreshFromCart(function (byVariant) {
      ctas.forEach(function (cta) {
        var vid = parseInt(cta.getAttribute('data-variant-id'), 10);
        if (byVariant[vid]) showStepper(cta, byVariant[vid]);
      });
    });

    // Dodanie do koszyka (AJAX, bez przeładowania)
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('.product-card__addform');
      if (!form) return;
      e.preventDefault();
      var cta = form.closest('[data-card-cta]');
      var vid = cta.getAttribute('data-variant-id');
      var btn = form.querySelector('[data-quick-add]');
      if (btn) btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          refreshFromCart(function (byVariant) { showStepper(cta, byVariant[vid] || 1); });
        })
        .catch(function () { if (btn) btn.disabled = false; });
    });

    // Zapamiętaj miejsce na liście, gdy klikasz „Wybierz opcje"
    document.addEventListener('click', function (e) {
      var choose = e.target.closest('.product-card__choose');
      if (!choose) return;
      var card = choose.closest('.product-card');
      try {
        sessionStorage.setItem('gfb-return', window.location.pathname + window.location.search);
        if (card && card.id) sessionStorage.setItem('gfb-return-card', card.id);
      } catch (err) {}
    });

    // Zmiana ilości +/- w koszyku z poziomu listy
    document.addEventListener('click', function (e) {
      var step = e.target.closest('[data-line-plus],[data-line-minus]');
      if (!step) return;
      var cta = step.closest('[data-card-cta]');
      if (!cta) return;
      var vid = cta.getAttribute('data-variant-id');
      var qtyEl = cta.querySelector('[data-line-qty]');
      var cur = parseInt(qtyEl.textContent, 10) || 0;
      var next = cur + (step.hasAttribute('data-line-plus') ? 1 : -1);
      if (next < 0) next = 0;
      cta.querySelectorAll('.product-card__step').forEach(function (b) { b.disabled = true; });
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: next })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          setCartCount(cart.item_count);
          if (next <= 0) { showButton(cta); }
          else { qtyEl.textContent = next; }
          cta.querySelectorAll('.product-card__step').forEach(function (b) { b.disabled = false; });
        })
        .catch(function () { cta.querySelectorAll('.product-card__step').forEach(function (b) { b.disabled = false; }); });
    });
  })();

  /* ------------------------------------------------------------------
     „Wybierz opcje" → po dodaniu wróć na listę w to samo miejsce
     ------------------------------------------------------------------ */
  (function () {
    // Na stronie produktu: jeśli przyszliśmy z listy, po dodaniu wróć tam
    var pform = document.querySelector('[data-product-form]');
    if (pform) {
      var form = pform.querySelector('form');
      var ret = null;
      try { ret = sessionStorage.getItem('gfb-return'); } catch (err) {}
      if (form && ret) {
        var marked = ret + (ret.indexOf('?') >= 0 ? '&' : '?') + 'gfb_added=1';
        var inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = 'return_to';
        inp.value = marked;
        form.appendChild(inp);
      }
    }

    // Po powrocie na listę: przewiń do kafelka, przy którym byliśmy
    var cardId = null;
    try { cardId = sessionStorage.getItem('gfb-return-card'); } catch (err) {}
    if (cardId) {
      var target = document.getElementById(cardId);
      if (target) {
        requestAnimationFrame(function () { target.scrollIntoView({ block: 'center' }); });
        try { sessionStorage.removeItem('gfb-return'); sessionStorage.removeItem('gfb-return-card'); } catch (err) {}
      }
    }

    // Potwierdzenie po realnym dodaniu (marker w URL z return_to)
    if (window.location.search.indexOf('gfb_added') >= 0) {
      showToast('✓ Dodano do koszyka');
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete('gfb_added');
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      } catch (err) {}
    }
  })();

  /* ------------------------------------------------------------------
     Baner „strona w budowie" — pełny ekran, funnel do starego sklepu
     ------------------------------------------------------------------ */
  (function () {
    var box = document.querySelector('[data-construction]');
    if (!box) return;
    var inEditor = window.Shopify && window.Shopify.designMode;
    var dismissed = false;
    try { dismissed = sessionStorage.getItem('gfb-construction') === '1'; } catch (err) {}
    var closable = box.querySelector('[data-construction-close]');
    if (!inEditor && !(dismissed && closable)) {
      box.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    if (closable) {
      closable.addEventListener('click', function () {
        box.hidden = true;
        document.body.style.overflow = '';
        try { sessionStorage.setItem('gfb-construction', '1'); } catch (err) {}
      });
    }
  })();

  function showToast(msg) {
    var t = document.createElement('div');
    t.className = 'gfb-toast';
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    setTimeout(function () {
      t.classList.remove('is-visible');
      setTimeout(function () { t.remove(); }, 350);
    }, 2600);
  }
})();
